<template>
  <svg :width="size" :height="size" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <template v-if="name === 'gear'">
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M4.9 19.1L7 17M17 7l2.1-2.1" />
    </template>
    <template v-else-if="name === 'wave'">
      <path d="M2 12h3l2-6 3 12 3-9 2 5 2-2h5" />
    </template>
    <template v-else-if="name === 'nodes'">
      <circle cx="5" cy="6" r="2" /><circle cx="19" cy="6" r="2" /><circle cx="12" cy="18" r="2" />
      <path d="M7 6h10M6.5 7.7l4.3 8.6M17.5 7.7l-4.3 8.6" />
    </template>
    <template v-else-if="name === 'pin'">
      <path d="M12 22s7-6.2 7-12a7 7 0 0 0-14 0c0 5.8 7 12 7 12z" /><circle cx="12" cy="10" r="2.5" />
    </template>
    <template v-else-if="name === 'download'">
      <path d="M12 3v12M6 11l6 6 6-6M4 21h16" />
    </template>
    <template v-else-if="name === 'chip'">
      <rect x="6" y="6" width="12" height="12" rx="2" /><path d="M9 2v4M15 2v4M9 18v4M15 18v4M2 9h4M2 15h4M18 9h4M18 15h4" />
    </template>
    <template v-else-if="name === 'code'">
      <path d="M8 6l-6 6 6 6M16 6l6 6-6 6M14 4l-4 16" />
    </template>
    <template v-else-if="name === 'badge'">
      <path d="M12 2l2.4 4.9 5.4.8-3.9 3.8.9 5.4L12 14.4l-4.8 2.5.9-5.4L4.2 7.7l5.4-.8z" />
    </template>
  </svg>
</template>

<script>
export default {
  name: 'BizIcon',
  props: { name: { type: String, required: true }, size: { type: Number, default: 40 } },
};
</script>
